import {FC} from 'react'
import {useLocation} from 'react-router-dom'
import queryString from 'query-string'
import {useCheckChangeEmailConfirmationToken} from 'hooks/api/changeEmailConfirmation'
import {Presenter} from './Presenter'

export const Show: FC = () => {
  const {search} = useLocation()
  const {confirmation_token: token} = queryString.parse(search)
  const {isLoading, isValid, errors} = useCheckChangeEmailConfirmationToken(
    (Array.isArray(token) ? token[0] : token) ?? undefined
  )

  return <Presenter isLoading={isLoading} isValid={isValid} errors={errors} />
}
